import { Button } from 'antd'
import React from 'react'

const UGButton = ({ children, ...rest }) => {
    return (
        <Button {...rest}>{children}</Button>
    )
}

export default UGButton